import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../../routes';
import { Contact } from '../../../../sic-lib/types/Contact';
import { ListType } from '../../../../sic-lib/types/Lists';
import MenuTableContactActions from '../MenuTableContactActions/MenuTableContactActions';
import TableRowCheckbox from '../TableRowCheckbox/TableRowCheckbox';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
    },
    textWrapper: {
        width: '0px',
        /* checkbox width (58px) + icon button width (56px) */
        maxWidth: 'calc(100% - 114px)',
    },
    navButton: {
        position: 'static',
        display: 'inline-block',
        width: '100%',
        maxWidth: '100%',
        textAlign: 'left',
        '&::before': {
            transition: 'background-color 80ms ease',
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            display: 'block',
            width: '0px',
            height: '0px',
            backgroundColor: 'transparent',
        },
        '&:hover': {
            '&::before': {
                width: '100%',
                height: '100%',
                backgroundColor: theme.palette.menuListHover.light,
            },
        },
    },
}));

interface Props {
    contact: Contact;
    appliedListId: number;
    appliedListType: ListType;
}

export default function TableContactInfo({ contact, appliedListId, appliedListType }: Props) {
    const { classes } = useStyles();
    const history = useHistory();

    const handleNavigate = () => {
        history.push(contactRoutes.setDetails(contact.contactId));
    };

    return (
        <React.Fragment>
            <Grid
                container
                direction="row"
                wrap="nowrap"
                alignItems="center"
                spacing={2}
                className={classes.root}
            >
                <Grid item xs="auto">
                    <TableRowCheckbox contactId={contact.contactId} />
                </Grid>
                <Grid item xs={true} className={classes.textWrapper}>
                    <ButtonBase onClick={handleNavigate} className={classes.navButton}>
                        <Typography variant="body1" noWrap gutterBottom>
                            {`${contact.firstName || ''} ${contact.lastName || ''}`.trim()}
                        </Typography>
                        <Typography variant="body2" noWrap color="textSecondary">
                            {contact.status || 'No Status'}
                        </Typography>
                    </ButtonBase>
                </Grid>
                <Grid item xs="auto">
                    <MenuTableContactActions
                        contact={contact}
                        appliedListId={appliedListId}
                        appliedListType={appliedListType}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
